/* @flow */
import { flatten } from 'lodash';
import { callApiEndpoint } from './index';
import utils from './utils';

import type { CartItem, WorklistItem } from 'types';

const findItems = async (): Promise<CartItem[]> => {
  const endpoint = 'cartitems/findCartItemForWorklistItemByUser';
  const response = await callApiEndpoint(endpoint, {
    method: 'POST',
    body: {
      elementsForPage: 999,
      end: 0,
      page: 0,
      sortField: 'dtModifica',
      start: 0,
    },
  });
  return response.map(utils.toCartItem);
};

const createItems = async (worklistItems: WorklistItem[]): Promise<CartItem[]> => {
  const endpoint = 'cartitems/addWorkListItemLicensingCartItem';
  const responses = [];
  for (const worklistItem of worklistItems) {
    const components = flatten((worklistItem.mergedComponents || []).map(c => c.components || []));
    const componentIds = components.map(c => c.right.id);
    const params = {
      worklistItemId: worklistItem.id,
      selectedTipiDirittoIds: componentIds,
    };
    responses.push(
      await callApiEndpoint(endpoint, {
        method: 'POST',
        body: params,
      })
    );
  }
  return responses.map(utils.toCartItem);
};

const deleteItems = async (cartItems: CartItem[]): Promise<number[]> => {
  const response = [];
  for (const item of cartItems) {
    response.push(
      await callApiEndpoint('cartitems/' + item.id + '/delete', {
        method: 'DELETE',
      })
    );
  }

  return response.map(item => item.cartItemId);
};

const buyLicensingCartItems = async (cartItems: CartItem[]): Promise<CartItem[]> => {
  const endpoint = 'cartitems/buyLicensingCartItem';
  const responses = [];
  for (const cartItem of cartItems) {
    const components = flatten(
      (cartItem.worklistItem.mergedComponents || []).map(c => c.components || [])
    );
    const componentIds = components.map(c => c.right.id);
    const params = {
      cartItemId: cartItem.id,
      tipoDirittoIds: componentIds,
    };

    responses.push(
      await callApiEndpoint(endpoint, {
        method: 'POST',
        body: params,
      })
    );
  }
  return cartItems;
};

export default {
  items: {
    find: findItems,
    create: createItems,
    delete: deleteItems,
    buy: buyLicensingCartItems,
  },
};
